/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {COLORS} from "@res/colors";

type Props = {
	text: string
}

export class UsernamePanel
	extends React.Component<Props> {

	render() {
		return <div style={{paddingLeft: 20, color: COLORS.systemGreen, fontSize: 18, fontWeight: 600}}>{this.props.text}</div>;
	}

}